export default __webpack_public_path__ + "static/media/hybrid_animals.13e24cde.png";